/* cvn-size-confirm.js — lifted verbatim out of snippets/cvn-size-confirm.liquid on 2026-09-25 (theme audit v77).
   It used to be an inline <script> re-sent with every page; as an asset it is minified by the CDN and cached.
   Execution point is unchanged: the snippet loads it (blocking, no defer) exactly where the block was.

   r17 (2026-10-01, Zeus): TWO QUESTIONS, IN ORDER. The Checkout click now runs
   two passes over the mis-sized lines. "Keep as is" lines get the dialog that
   has always been here ("One piece isn't your recommended size", the size we
   recommend beside the one chosen, [Let me check the size] / [I'll take this
   size]). Lines answered "It's a gift" used to be skipped — a gift is already
   an explicit "not for me" — and now get their OWN dialog, after the first one
   has been answered Yes (or straight away when there is nothing to keep):
   "One piece is marked as a gift", the chosen size with NO recommendation
   beside it (the recipient's size is unknown by definition), the same
   made-to-order fact and the same assurance, and then the nudge this dialog
   exists for — a gift card lets the recipient pick their own size — with
   [Build the gift card] / [I'll take this size]. Build lands on the gift card
   page with those pieces already in the picks, in the colours chosen here
   (?gift_picks=handle:variant,… — cvn-gift-picks.js#preloadFromUrl). The
   cart submits only once every dialog in the chain has been answered Yes.
   Neither dialog remembers an answer across Checkout clicks: the cart can
   change in between, and each click asks about the lines it holds then. */
  (function () {
    if (window.cvnSizeConfirmInit) return;
    window.cvnSizeConfirmInit = true;

    var POLICY = window.cvnScPolicy || '/policies/refund-policy';
    var CHECKOUT_SEL = '#CartDrawer-Checkout, .cart__checkout-button';
    var el = null;
    var pendingBtn = null;
    // the gift-marked lines waiting for their turn, once the keep dialog is
    // answered Yes; empty when there is nothing to ask next
    var pendingGift = [];
    // set for the one submit we let through, so our own capture listener does
    // not re-open the dialog on the click we just authorised
    var bypass = false;

    function recsMap() {
      try { return JSON.parse(localStorage.getItem('cvn_sf_recs') || 'null'); } catch (e) { return null; }
    }

    function giftUrl() {
      var g = document.querySelector('cvn-size-guard[data-cvn-gift-url]');
      return g ? (g.getAttribute('data-cvn-gift-url') || '') : '';
    }

    // the cart row's product handle, off the name link it already carries
    // (/products/<handle>?variant=…) — the pick needs it, the dialog does not
    function handleOf(row) {
      var a = row.querySelector('.cart-item__name');
      var m = /\/products\/([a-z0-9-]+)/i.exec(a ? (a.getAttribute('href') || '') : '');
      return m ? m[1] : '';
    }

    /* WHICH LINES NEED ASKING. The verdict "not your recommended size" is NOT
       re-derived here — cvn-size-guard's decorator already owns that rule, and
       a second copy of it is exactly the kind of duplicate that drifts. We run
       the decorator (idempotent) and then read ITS mark off each row. The only
       thing read independently is the shopper's per-line answer, from the same
       sessionStorage key the pills write. r17: both answers are collected in
       one pass — `keep` for the first dialog, `gift` for the second. */
    function linesToConfirm(scope) {
      try { if (window.cvnDecorateLines) window.cvnDecorateLines(); } catch (e) {}
      var recs = recsMap();
      var out = { keep: [], gift: [] };
      (scope || document).querySelectorAll('[data-cvn-cid]').forEach(function (row) {
        if (!row.querySelector('.cvn-line-tag--warn, .cvn-line-warn')) return;
        var key = row.getAttribute('data-cvn-line-key') || '';
        var sel = 'keep';
        try { sel = sessionStorage.getItem('cvn_sel_' + key) || 'keep'; } catch (e) {}
        var img = row.querySelector('.cart-item__image');
        var nameEl = row.querySelector('.cart-item__name');
        var rec = recs && recs['blank-' + row.getAttribute('data-cvn-cid')];
        var item = {
          src: img ? (img.currentSrc || img.src) : '',
          name: nameEl ? nameEl.textContent.trim() : '',
          size: row.getAttribute('data-cvn-line-size') || '',
          rec: (rec && rec.pick) || '',
          handle: handleOf(row),
          vid: key.split(':')[0] || ''
        };
        (sel === 'gift' ? out.gift : out.keep).push(item);
      });
      return out;
    }

    // small counts read warmer spelled out, which is the house editorial
    // style; past ten a numeral is easier to scan than a word
    function numberWord(n) {
      var w = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine', 'Ten'];
      return n <= 10 ? w[n] : String(n);
    }

    // ⚠ "piece", never "item". It is the word the site already uses (Our
    // Pieces, "every piece is made to order"); "item" is warehouse language.
    function titleFor(n) {
      return n === 1
        ? 'One piece isn’t your recommended size'
        : numberWord(n) + ' pieces aren’t your recommended sizes';
    }

    // the gift dialog states a fact the shopper set themselves ("marked as a
    // gift" is their own pill), so it reads as a reminder, not a verdict
    function giftTitleFor(n) {
      return n === 1
        ? 'One piece is marked as a gift'
        : numberWord(n) + ' pieces are marked as gifts';
    }

    // ⚠ EVERY STRING IN THIS DIALOG AGREES WITH THE COUNT. The title, the
    // consent sentence and BOTH buttons switch together off the same `one`
    // flag, so there is no path where a single crewneck is described as
    // "these sizes" or answered with "I'll take them".
    function consentFor(n) {
      return n === 1
        ? 'Every piece is made to order, so if this size doesn’t fit, it isn’t something we can take back.'
        : 'Every piece is made to order, so if these sizes don’t fit, they aren’t something we can take back.';
    }

    // ⚠ THE REASSURANCE IS ITS OWN LINE AND ITS OWN SENTENCE. Run on after the
    // limit it was read as more terms and skipped with them, which wasted the
    // one line that makes the limit feel fair rather than mean.
    // "defective" carries the physical fault; "isn't what you ordered" carries
    // OUR mistake. They are two different promises and pairing "flawed" with
    // "defective" would have said the first one twice and dropped the second.
    function assuranceFor(n) {
      return n === 1
        ? 'If it arrives defective, or it isn’t what you ordered, we’ll always put that right.'
        : 'If anything arrives defective, or it isn’t what you ordered, we’ll always put that right.';
    }

    // the one line the gift dialog is for. "their size" keeps the recipient in
    // the sentence; "never expires" is the fact that makes the card the safe
    // choice rather than the lesser one
    var NUDGE = 'Not sure of their size? Give a gift card instead. Pick the pieces you’d want them to have and write your note; they choose their own size and color, and it never expires.';
    var GIFT_ICON = '<svg class="cvn-gift-ic" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3.5 9h17v3.5h-17z"/><path d="M5 12.5V20h14v-7.5"/><path d="M12 9v11"/><path d="M12 9c-2.2 0-4-1-4-2.3 0-1 .8-1.7 1.7-1.7C11 5 12 7 12 9zm0 0c2.2 0 4-1 4-2.3 0-1-.8-1.7-1.7-1.7C13 5 12 7 12 9z"/></svg>';

    function close() {
      if (el) { el.remove(); el = null; }
      pendingBtn = null;
      pendingGift = [];
    }

    function backToCart() {
      // ⚠ READ THIS BEFORE close(), which nulls pendingBtn.
      // Where the shopper came from decides where "No" puts them back, and the
      // two surfaces want OPPOSITE things. Raised from the DRAWER, "let me
      // check the sizes" has to reopen the drawer or they land on whatever
      // page was behind it with the cart gone. Raised from the CART PAGE, the
      // rows are already on screen — opening the drawer there covers the exact
      // lines they just said they wanted to check, with their own edit
      // controls behind a panel. Same button, same words, opposite action.
      var fromDrawer = !!(pendingBtn && pendingBtn.closest('cart-drawer'));
      close();
      if (!fromDrawer) return;
      var d = document.querySelector('cart-drawer');
      // the drawer is normally still open underneath; reopen only if it is
      // not, never unconditionally (a second open() re-runs the slide).
      if (d && !d.classList.contains('active') && typeof d.open === 'function') {
        try { d.open(); } catch (e) {}
      }
    }

    function proceed() {
      var btn = pendingBtn;
      close();
      if (!btn) return;
      bypass = true;
      // if the submit somehow does not navigate, the gate must close again
      // rather than stay open for every later click
      setTimeout(function () { bypass = false; }, 5000);
      var form = btn.form || (btn.getAttribute('form') && document.getElementById(btn.getAttribute('form'))) || btn.closest('form');
      if (form && typeof form.requestSubmit === 'function') {
        // requestSubmit keeps the SUBMITTER, so name="checkout" still reaches
        // /cart — form.submit() would drop it and just reload the cart
        form.requestSubmit(btn);
      } else if (form) {
        var hidden = document.createElement('input');
        hidden.type = 'hidden';
        hidden.name = btn.getAttribute('name') || 'checkout';
        hidden.value = btn.getAttribute('value') || '';
        form.appendChild(hidden);
        form.submit();
      } else {
        btn.click();
      }
    }

    // Yes on the keep dialog: the gift lines, if any, get their turn before
    // the cart submits; Yes on the gift dialog is the end of the chain
    function advance() {
      if (pendingGift.length && giftUrl()) {
        var btn = pendingBtn, gift = pendingGift;
        if (el) { el.remove(); el = null; }
        pendingGift = [];
        openGift(gift, btn);
        return;
      }
      proceed();
    }

    // "Build the gift card": the gift page, with these pieces already in the
    // picks in the colours chosen here. A full navigation on purpose — the
    // drawer closes with the page, and the picks arrive through the URL.
    function buildGiftCard(items) {
      var base = giftUrl();
      if (!base) return;
      var picks = items.map(function (it) { return it.handle ? it.handle + (it.vid ? ':' + it.vid : '') : ''; }).filter(Boolean).join(',');
      close();
      window.location.href = base + (base.indexOf('?') > -1 ? '&' : '?') + 'gift_picks=' + encodeURIComponent(picks);
    }

    function renderRows(list, items, withRec) {
      items.forEach(function (it) {
        var li = document.createElement('li');
        li.className = 'cvn-sc__item';
        var im = document.createElement('img');
        im.className = 'cvn-sc__thumb';
        im.setAttribute('alt', '');
        im.setAttribute('loading', 'lazy');
        if (it.src) im.src = it.src;
        var meta = document.createElement('div');
        meta.className = 'cvn-sc__meta';
        var nm = document.createElement('span');
        nm.className = 'cvn-sc__name';
        // textContent, never innerHTML: a product title is content, and this
        // one has already been through Liquid's escaping once
        nm.textContent = it.name;
        var sz = document.createElement('span');
        sz.className = 'cvn-sc__size';
        var chosen = document.createElement('span');
        chosen.className = 'cvn-sc__chosen';
        chosen.textContent = 'Size ' + it.size;
        sz.appendChild(chosen);
        // the gift rows carry NO recommendation (Zeus, r17): the size that
        // matters is the recipient's, and nobody here knows it
        if (withRec && it.rec) sz.appendChild(document.createTextNode(' · we recommend ' + it.rec));
        meta.appendChild(nm);
        meta.appendChild(sz);
        li.appendChild(im);
        li.appendChild(meta);
        list.appendChild(li);
      });
    }

    function open(items, btn) {
      close();
      pendingBtn = btn;
      el = document.createElement('div');
      el.className = 'cvn-sc';
      el.setAttribute('role', 'dialog');
      el.setAttribute('aria-modal', 'true');
      el.setAttribute('aria-label', titleFor(items.length));
      el.innerHTML =
        '<div class="cvn-sc__panel">' +
        '<button type="button" class="cvn-sc__x" data-cvn-sc-no aria-label="Close">&times;</button>' +
        '<h2 class="cvn-sc__title"></h2>' +
        '<ul class="cvn-sc__list"></ul>' +
        // ⚠ THE CONSENT IS A PLAIN FACT, NOT AN "I HAVE READ" LINE, AND IT IS
        // THE BUTTON THAT CARRIES IT. The old sentence asserted the shopper
        // had read a policy they had not opened, and made them agree to a
        // DOCUMENT instead of understand a CONSEQUENCE — so the one fact that
        // matters (the piece does not exist yet, there is nothing to restock)
        // never got said. Stating the reason and letting "I'll take this size"
        // be the affirmative act is both better writing and a stronger record
        // of consent than boilerplate nobody reads.
        // ⚠ AND IT NAMES WHAT *IS* COVERED. A limit stated alone reads
        // defensive; paired with the promise about flaws it reads fair, which
        // is what keeps this on-brand rather than legal.
        // Sits directly under the rows it covers, so "this size" has a
        // visible referent. It was previously repeated on EVERY cart line.
        '<p class="cvn-sc__consent"></p>' +
        '<p class="cvn-sc__assure"></p>' +
        '<p class="cvn-sc__policy"><a target="_blank" rel="noopener">Read our return policy</a></p>' +
        '<div class="cvn-sc__btns">' +
        // ⚠ DOM ORDER IS No THEN Yes, and the CSS must not reverse it.
        // No is the first pill and carries the solid fill; Yes is the second
        // and is the quiet outline. This dialog exists to slow a decision
        // down, so the emphasis sits on the cautious answer, not the fast one.
        '<button type="button" class="cvn-sc__btn cvn-sc__btn--no" data-cvn-sc-no></button>' +
        '<button type="button" class="cvn-sc__btn cvn-sc__btn--yes" data-cvn-sc-yes></button>' +
        '</div></div>';
      var one = items.length === 1;
      el.querySelector('.cvn-sc__title').textContent = titleFor(items.length);
      // the link is its own element in the markup above, so every one of these
      // is plain text and goes in as textContent — no product data reaches
      // innerHTML anywhere in this dialog
      el.querySelector('.cvn-sc__consent').textContent = consentFor(items.length);
      el.querySelector('.cvn-sc__assure').textContent = assuranceFor(items.length);
      el.querySelector('.cvn-sc__policy a').setAttribute('href', POLICY);
      el.querySelector('.cvn-sc__btn--yes').textContent = one
        ? 'I’ll take this size'
        : 'I’ll take these sizes';
      el.querySelector('.cvn-sc__btn--no').textContent = one
        ? 'Let me check the size'
        : 'Let me check the sizes';
      renderRows(el.querySelector('.cvn-sc__list'), items, true);
      document.body.appendChild(el);
      // the cautious answer takes focus: this dialog exists to slow a decision
      // down, not to make "yes" one keystroke away
      var no = el.querySelector('.cvn-sc__btn--no');
      if (no) no.focus();
    }

    // The gift dialog (r17). Same panel, same bones, three differences: the
    // rows show the chosen size alone; the nudge sits between the policy line
    // and the buttons, in its own box with the gift glyph; and the solid,
    // first, focused answer is the gift card — the cautious choice here is the
    // one that lets the recipient pick their own size.
    function openGift(items, btn) {
      if (el) { el.remove(); el = null; }
      pendingBtn = btn;
      pendingGift = [];
      el = document.createElement('div');
      el.className = 'cvn-sc cvn-sc--gift';
      el.setAttribute('role', 'dialog');
      el.setAttribute('aria-modal', 'true');
      el.setAttribute('aria-label', giftTitleFor(items.length));
      el.innerHTML =
        '<div class="cvn-sc__panel">' +
        '<button type="button" class="cvn-sc__x" data-cvn-sc-no aria-label="Close">&times;</button>' +
        '<h2 class="cvn-sc__title"></h2>' +
        '<ul class="cvn-sc__list"></ul>' +
        '<p class="cvn-sc__consent"></p>' +
        '<p class="cvn-sc__assure"></p>' +
        '<p class="cvn-sc__policy"><a target="_blank" rel="noopener">Read our return policy</a></p>' +
        '<div class="cvn-sc__nudge">' + GIFT_ICON + '<p class="cvn-sc__nudge-text"></p></div>' +
        '<div class="cvn-sc__btns">' +
        // DOM order: the gift card first and solid, the size second and quiet
        '<button type="button" class="cvn-sc__btn cvn-sc__btn--no cvn-sc__btn--build" data-cvn-sc-gift></button>' +
        '<button type="button" class="cvn-sc__btn cvn-sc__btn--yes" data-cvn-sc-yes></button>' +
        '</div></div>';
      var one = items.length === 1;
      el.querySelector('.cvn-sc__title').textContent = giftTitleFor(items.length);
      el.querySelector('.cvn-sc__consent').textContent = consentFor(items.length);
      el.querySelector('.cvn-sc__assure').textContent = assuranceFor(items.length);
      el.querySelector('.cvn-sc__policy a').setAttribute('href', POLICY);
      el.querySelector('.cvn-sc__nudge-text').textContent = NUDGE;
      el.querySelector('.cvn-sc__btn--build').textContent = 'Build the gift card';
      el.querySelector('.cvn-sc__btn--yes').textContent = one
        ? 'I’ll take this size'
        : 'I’ll take these sizes';
      renderRows(el.querySelector('.cvn-sc__list'), items, false);
      el.__cvnItems = items;
      document.body.appendChild(el);
      var first = el.querySelector('.cvn-sc__btn--build');
      if (first) first.focus();
    }

    document.addEventListener('click', function (event) {
      if (!event.target.closest) return;
      if (event.target.closest('[data-cvn-sc-yes]')) {
        event.preventDefault();
        advance();
        return;
      }
      if (event.target.closest('[data-cvn-sc-gift]')) {
        event.preventDefault();
        buildGiftCard((el && el.__cvnItems) || []);
        return;
      }
      if (event.target.closest('[data-cvn-sc-no]')) {
        event.preventDefault();
        backToCart();
        return;
      }
      // backdrop: anywhere inside the dialog but outside the panel
      if (event.target.closest('.cvn-sc') && !event.target.closest('.cvn-sc__panel')) {
        event.preventDefault();
        backToCart();
        return;
      }
      var btn = event.target.closest(CHECKOUT_SEL);
      if (!btn || btn.disabled || bypass) return;
      // the UNMEASURED guard owns a locked button: that shopper has no
      // recommendations at all, so the two cases can never both apply
      if (btn.hasAttribute('data-cvn-locked')) return;
      /* ⚠ SCOPE IS NOT OPTIONAL ON THE CART PAGE. The cart DRAWER is rendered
         in the layout on every page, so /cart holds two copies of every line:
         the page's rows and the drawer's. Falling back to `document` there
         counts both and the dialog announces "Four pieces" for a two-line
         cart, with four thumbnails. The drawer's own button scopes to its
         cart-drawer; the page's button is in main-cart-footer, a different
         section from the rows, so it cannot reach them with closest() and is
         pointed at the page's items container instead. */
      var scope = btn.closest('cart-drawer') || document.getElementById('main-cart-items') || document;
      var found = linesToConfirm(scope);
      // the gift dialog needs a gift card to point at; without one (the
      // product unpublished) those lines are left alone, as before r17
      var gift = giftUrl() ? found.gift : [];
      if (!found.keep.length && !gift.length) return;
      event.preventDefault();
      event.stopPropagation();
      if (found.keep.length) {
        open(found.keep, btn);
        pendingGift = gift;
      } else {
        openGift(gift, btn);
      }
    }, true);

    document.addEventListener('keydown', function (event) {
      if (el && event.key === 'Escape') {
        event.preventDefault();
        backToCart();
      }
    });

    // a soft navigation swaps #MainContent under us; a modal parked on <body>
    // would otherwise stand over a page it was never about
    document.addEventListener('cvn:navigated', close);
  })();
